<generic-search-page PageTitle="Invoices" [filters]="filterCategories" [SearchForRows]="searchFn" [EditRow]="editFn" [SearchHistoryType]="searchHistoryType">
  <div class="pull-right" page-controls></div>
  <invoice-search-results results-grid [rows]="SearchPageComponent()?.data()" (onEdit)="SearchPageComponent()?.edit($event)"
    (sortChanged)="SearchPageComponent()?.onSortChange($event)"></invoice-search-results>
</generic-search-page>